import { configureStore } from '@reduxjs/toolkit'
import loaderSlice from './Slices/loaderSlice'
import AllAvailableAccess from './Slices/AllAvailableAccess'
import apiCacheSlice from './Slices/apiCacheSlice'

export const store = configureStore({
    reducer: {
        loader: loaderSlice,
        allAvailableAccess: AllAvailableAccess,
        apiCache: apiCacheSlice,
    },
})